import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const updateAlias = createAsyncThunk(
  "updateAlias",
  async (values, { rejectWithValue }) => {
    try {
      const { id, alias_name } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/${id}`,
        { alias_name },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error || "Server error";
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data.errors.alias_name?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const updateEmail = createAsyncThunk(
  "updateEmail",
  async (values, { rejectWithValue }) => {
    try {
      const { id, email } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/${id}`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error;
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data?.errors?.email?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const updateMobNo = createAsyncThunk(
  "updateMobNo",
  async (values, { rejectWithValue }) => {
    try {
      const { id, mob_no } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/${id}`,
        { mob_no },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error;
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data?.errors?.mob_no?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const otpGenerateMob = createAsyncThunk(
  "otpGenerateMob",
  async (values, { rejectWithValue }) => {
    try {
      const { mob_no } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/verify/mobile`,
        { mob_no },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error;
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data?.errors?.mob_no?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const verifyOtpMob = createAsyncThunk(
  "verifyOtpMob",
  async (values, { rejectWithValue }) => {
    try {
      const { mob_no, passcode } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/verify/mobile`,
        { mob_no, passcode },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error;
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data?.errors?.mob_no?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const otpGenerateEmail = createAsyncThunk(
  "otpGenerateEmail",
  async (values, { rejectWithValue }) => {
    try {
      const { email } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/register/email`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },

          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error;
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data?.errors?.mob_no?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const verifyOtpEmail = createAsyncThunk(
  "verifyOtpEmail",
  async (values, { rejectWithValue }) => {
    try {
      const { email, passcode } = values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/register/email`,
        { email, passcode },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },

          validateStatus: () => true,
        },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        return data;
      }

      let errorMessage = "Unknown error";

      if (data?.status === 500) {
        errorMessage = data?.error;
      } else if (data?.errors) {
        if (data.errors.user_unauthorized) {
          errorMessage = data.errors.user_unauthorized[0];
        } else {
          errorMessage = data?.errors?.mob_no?.[0] || "Unknown error";
        }
      } else {
        errorMessage =
          data?.errors?.base?.[0] ||
          data?.errors?.user_unauthorized?.[0] ||
          "Unknown error";
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      const message = error?.response?.data || error.message;
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    aliasIsLoading: false,
    aliasData: null,
    aliasError: null,
    emailIsLoading: false,
    emailData: null,
    emailError: null,
    mobNoIsLoading: false,
    otpMsg: null,
    otpMsgLoading: false,
    otpMsgErr: null,
    verificationMsg: null,
    verificationMsgLoading: false,
    verificationMsgErr: null,
    mobNoData: null,
    mobNoError: null,
    otpEmail: null,
    otpEmailLoading: false,
    otpEmailErr: null,
    verificationEmail: null,
    verificationEmailLoading: false,
    verificationEmailErr: null,
  },
  reducers: {
    resetAliasName(state) {
      state.aliasData = null;
      state.aliasError = null;
      state.aliasIsLoading = null;
    },
    resetMobNum(state) {
      state.mobNoData = null;
      state.mobNoError = null;
      state.mobNoIsLoading = null;
    },
    resetEmail(state) {
      state.emailData = null;
      state.emailError = null;
      state.emailIsLoading = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAlias.pending, (state, action) => {
      state.aliasIsLoading = true;
    });
    builder.addCase(updateAlias.fulfilled, (state, action) => {
      state.aliasIsLoading = false;
      state.aliasData = action.payload;
      CommonToast({
        text: "Alias updated successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    });
    builder.addCase(updateAlias.rejected, (state, action) => {
      state.aliasIsLoading = false;
      state.aliasError = action.payload;
      CommonToast({
        text: action?.payload?.errors?.base[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    });
    builder.addCase(updateEmail.pending, (state, action) => {
      state.emailIsLoading = true;
    });
    builder.addCase(updateEmail.fulfilled, (state, action) => {
      state.emailIsLoading = false;
      state.emailData = action.payload;
      CommonToast({
        text: "Email updated successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    });
    builder.addCase(updateEmail.rejected, (state, action) => {
      state.emailIsLoading = false;
      state.emailError = action.payload;
      CommonToast({
        text: action?.payload?.errors?.email[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    });
    builder.addCase(updateMobNo.pending, (state, action) => {
      state.mobNoIsLoading = true;
    });
    builder.addCase(updateMobNo.fulfilled, (state, action) => {
      state.mobNoIsLoading = false;
      state.mobNoData = action.payload;
      CommonToast({
        text: "Contact number updated successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    });
    builder.addCase(updateMobNo.rejected, (state, action) => {
      state.mobNoIsLoading = false;
      state.mobNoError = action.payload;
      CommonToast({
        text: action?.payload?.errors?.mobile[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    });
    builder.addCase(otpGenerateMob.pending, (state, action) => {
      state.otpMsgLoading = true;
    });
    builder.addCase(otpGenerateMob.fulfilled, (state, action) => {
      state.otpMsgLoading = false;
      state.otpMsg = action.payload;
    });
    builder.addCase(otpGenerateMob.rejected, (state, action) => {
      state.otpMsgLoading = false;
      state.otpMsgErr = action.payload;
    });
    builder.addCase(verifyOtpMob.pending, (state, action) => {
      state.verificationMsgLoading = true;
    });
    builder.addCase(verifyOtpMob.fulfilled, (state, action) => {
      state.verificationMsgLoading = false;
      state.verificationMsg = action.payload;
    });
    builder.addCase(verifyOtpMob.rejected, (state, action) => {
      state.verificationMsgLoading = false;
      state.verificationMsgErr = action.payload;
    });
    builder.addCase(otpGenerateEmail.pending, (state, action) => {
      state.otpEmailLoading = true;
    });
    builder.addCase(otpGenerateEmail.fulfilled, (state, action) => {
      state.otpEmailLoading = false;
      state.otpEmail = action.payload;
    });
    builder.addCase(otpGenerateEmail.rejected, (state, action) => {
      state.otpEmailLoading = false;
      state.otpEmailErr = action.payload;
    });
    builder.addCase(verifyOtpEmail.pending, (state, action) => {
      state.verificationEmailLoading = true;
    });
    builder.addCase(verifyOtpEmail.fulfilled, (state, action) => {
      state.verificationEmailLoading = false;
      state.verificationEmail = action.payload;
    });
    builder.addCase(verifyOtpEmail.rejected, (state, action) => {
      state.verificationEmailLoading = false;
      state.verificationEmailErr = action.payload;
    });
  },
});

export const { resetEmail, resetMobNum, resetAliasName } = userSlice.actions;

export default userSlice.reducer;
